module.exports = require("d3-quadtree");